import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Row, Card, Button } from 'react-bootstrap';
import { getUserId } from '../../helpers/session';
import {
    createPerson, getStateList, getCountryList,
    getPersonInfo, editPerson, getPersonConfig
} from '../../actions/person';
import { FormValidator } from '../../helpers/form-validator';
import '../../../assets/css/react-datetime.css';
import { getQueryParams } from '../../helpers/common';
import { CardContainer } from '../widgets/CardContainer';
import { Icon, Validator, Form, Heading5, TitleIcon } from '../widgets';

class PersonForm extends React.Component {
    constructor(props) {
        super(props);
        this.validator = this.getRules();
        this.state = {
            validation: this.validator.valid(),
            farmId: 0,
            personId: null,
            firstName: '',
            lastName: '',
            person_role_id: '',
            mobile: '',
            stateId: '',
            state: '',
            countryId: 1,
            country: '',
            city: '',
            zipcode: '',
        }

        this.savePersonnel = this.savePersonnel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleRole = this.handleRole.bind(this);
        this.handleCountry = this.handleCountry.bind(this);
        this.handleState = this.handleState.bind(this);
        this.bindValues = this.bindValues.bind(this);
        this.submitted = false;
        this.isEditMode = false;
        this.returnUrl = '';
    }

    getRules() {
        return new FormValidator([
            {
                field: 'firstName',
                method: 'isEmpty',
                validWhen: false,
                message: 'First Name is required.'
            },
            {
                field: 'lastName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Last Name is required.'
            },
            {
                field: 'person_role_id',
                method: 'isInt',
                validWhen: true,
                message: 'Role is required'
            },
            {
                field: 'mobile',
                method: 'isEmpty',
                validWhen: false,
                disabled: true,
                message: 'Mobile number is required'
            },
            {
                field: 'mobile',
                method: 'isLength',
                validWhen: true,
                args: [{ min: 10, max: 10 }],
                validateEmpty: false,
                message: 'Please enter valid mobile number'
            },
            {
                field: 'zipcode',
                method: 'isLength',
                validWhen: true,
                args: [{ min: 6, max: 6 }],
                validateEmpty: false,
                message: 'Please enter valid zipcode'
            }
        ])
    }

    componentDidMount() {
        const params = this.props.match.params;
        const q = getQueryParams(this.props.location.search);

        if (q.t && q.t.toLowerCase() === 'sub') this.returnUrl = `/home/farm/${params.farmId}/map/person`;
        else this.returnUrl = `/home/farm/${params.farmId}/person/list`;

        this.isEditMode = (params && params.hasOwnProperty('id'));
        this.setState({ personId: params.id, farmId: params.farmId });

        if (this.isEditMode) this.props.dispatch(getPersonInfo({ person_uuid: params.id }));
        this.props.dispatch(getPersonConfig());
        this.props.dispatch(getCountryList());
        this.props.dispatch(getStateList({ country_id: 1 }));
    }

    componentDidUpdate(prevProps) {
        if (Object.keys(this.props.personInfo).length > 0 && prevProps.personInfo !== this.props.personInfo)
            this.bindValues();
    }

    bindValues() {
        this.submitted = false;
        const r = this.props.personInfo;
        const params = {
            firstName: r.first_name,
            lastName: r.last_name,
            person_role_id: r.person_role_id,
            mobile: (r.phone == null) ? '' : r.phone,
            city: (r.city == null) ? '' : r.city,
            stateId: (r.state_id == null) ? 0 : r.state_id,
            countryId: r.country_id,
            zipcode: (r.zipcode == null) ? '' : r.zipcode,
            validation: this.validator.valid()
        }
        this.setState(params);
    }

    handleChange(event) {
        const { name, value } = event.target;
        this.setState({ [name]: value })
    }

    savePersonnel() {
        const validation = this.validator.validate(this.state);
        this.setState({ validation });
        this.submitted = true;
        if (validation.isValid) {
            const success = () => { this.props.history.push(this.returnUrl); };

            const params = {
                farm_uuid: this.state.farmId,
                first_name: this.state.firstName,
                last_name: this.state.lastName,
                person_role_id: this.state.person_role_id,
                phone: this.state.mobile,
                city: this.state.city,
                state_id: (this.state.stateId > 0) ? this.state.stateId : null,
                country_id: (this.state.countryId > 0) ? this.state.countryId : 1,
                zipcode: this.state.zipcode,
                created_by: getUserId()
            }
            if (!this.isEditMode) this.props.dispatch(createPerson(params, success));
            else {
                params.person_uuid = this.state.personId;
                this.props.dispatch(editPerson(params, success));
            }
        }
    }

    handleRole(selectedOption) {
        const id = selectedOption ? parseInt(selectedOption.value) : null;
        this.setState({ person_role_id: id });
    }

    handleCountry(selectedOption) {
        const { value, label } = selectedOption ? selectedOption : { value: 0, label: '' };
        this.setState({ countryId: value, country: label });
    }

    handleState(selectedOption) {
        const { value, label } = selectedOption ? selectedOption : { value: 0, label: '' };
        this.setState({ stateId: value, state: label });
    }

    render() {
        const validation = this.submitted ? this.validator.validate(this.state) : this.state.validation;

        return (
            <CardContainer>
                <Card className="card-form">
                    <Card.Header>
                        <Card.Title>
                            <Heading5>
                                <TitleIcon className="fa fa-user" />{this.isEditMode ? 'Edit Personnel' : 'Add Personnel'}
                            </Heading5>
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <Form.Cell>
                                <Form.Group>
                                    <Validator validation={validation.firstName}>
                                        <Form.Label>First Name<Validator.Mand /></Form.Label>
                                        <Form.Control size="sm" type="text" placeholder="Enter the first name" name="firstName"
                                            value={this.state.firstName} onChange={this.handleChange} />
                                        <Validator.Text />
                                    </Validator>
                                </Form.Group>
                            </Form.Cell>

                            <Form.Cell>
                                <Form.Group>
                                    <Validator validation={validation.lastName}>
                                        <Form.Label>Last Name<Validator.Mand /></Form.Label>
                                        <Form.Control size="sm" type="text" placeholder="Enter the last name" className="form-control"
                                            name="lastName" value={this.state.lastName} onChange={this.handleChange} />
                                        <Validator.Text />
                                    </Validator>
                                </Form.Group>
                            </Form.Cell>

                            <Form.Cell>
                                <Form.Group >
                                    <Validator validation={validation.person_role_id}>
                                        <Form.Label>Role<Validator.Mand /></Form.Label>
                                        <Form.Select name="person_role_id" className="select-control-sm" placeholder="Select role"
                                            value={this.state.person_role_id} options={this.props.personRoleList} onChange={this.handleRole}>
                                        </Form.Select>
                                        <Validator.Text />
                                    </Validator>
                                </Form.Group>
                            </Form.Cell>

                            <Form.Cell>
                                <Form.Group>
                                    <Validator validation={validation.mobile}>
                                        <Form.Label>Mobile #</Form.Label>
                                        <Form.Control size="sm" type="number" placeholder="Enter the mobile " name="mobile"
                                            value={this.state.mobile} onChange={this.handleChange} />
                                        <Validator.Text />
                                    </Validator>
                                </Form.Group>
                            </Form.Cell>

                            <Form.Cell>
                                <Form.Group>
                                    <Form.Label>Country</Form.Label>
                                    <Form.Select disabled={true} className="select-control-sm" placeholder="Enter the country" name="country"
                                        value={this.state.countryId} options={this.props.countryList.map(e => {
                                            return ({ value: e.country_id, label: e.country });
                                        })} onChange={this.handleCountry} />
                                </Form.Group>
                            </Form.Cell>

                            <Form.Cell>
                                <Form.Group>
                                    <Form.Label>State</Form.Label>
                                    <Form.Select className="select-control-sm" allowCreate={true} placeholder="Enter the state"
                                        value={this.state.stateId} name="State" options={this.props.stateList.map(e => {
                                            return ({ value: e.state_id, label: e.state });
                                        })} onChange={this.handleState} />
                                </Form.Group>
                            </Form.Cell>

                            <Form.Cell>
                                <Form.Group>
                                    <Form.Label>City</Form.Label>
                                    <Form.Control size="sm" type="text" placeholder="Enter the city" name="city" value={this.state.city} onChange={this.handleChange} />
                                </Form.Group>
                            </Form.Cell>

                            <Form.Cell>
                                <Form.Group>
                                    <Validator validation={validation.zipcode}>
                                        <Form.Label>Zipcode</Form.Label>
                                        <Form.Control size="sm" type="number" placeholder="Enter the zipcode" value={this.state.zipcode} name="zipcode" onChange={this.handleChange} />
                                        <Validator.Text />
                                    </Validator>
                                </Form.Group>
                            </Form.Cell>

                        </Row>
                    </Card.Body>
                    <Card.Footer>
                        <Button type="button" className="btn btn-primary btn-sm float-right ml-3" onClick={this.savePersonnel}><Icon className="fa fa-floppy-o"></Icon> Save</Button>
                        <NavLink className="btn btn-danger btn-sm float-right" to={this.returnUrl}><i className="fa fa-times-circle"></i> Cancel</NavLink>
                    </Card.Footer>
                </Card>
            </CardContainer >
        )
    }
}
const mapStateToProps = state => ({
    stateList: state.person.stateList,
    countryList: state.person.countryList,
    personInfo: state.person.personInfo,
    personRoleList: state.person.personRoleList.map(e => ({
        value: e.person_role_id, label: e.person_role_name
    }))
});

export default connect(mapStateToProps)(PersonForm);